function Banner(props) {
  return (
    <section className="section clients">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="section-title text-center">
              <h2>Your Partnership is Our Future</h2>
              <div className="divider mx-auto my-4"></div>
              <p>
                강원특별자치도자동차검사정비사업조합과의 협력을 통해
                <br />
                더욱 빛나는 미래를 만들어가실 파트너사를 기다립니다.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row clients-logo">
          {props.banners.map((banner, idx) => (
            <div className="col-lg-3 col-sm-12 col-md-6" key={idx}>
              <div className="client-thumb">
                {banner.bn_url ? (
                  <a href={banner.bn_url} target="_blank" rel="noreferrer">
                    <img
                      src={banner.file_url}
                      alt={banner.file_url}
                      className="img-fluid2"
                    />
                  </a>
                ) : (
                  <img
                    src={banner.file_url}
                    alt={banner.file_url}
                    className="img-fluid2"
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Banner;
